import { Component, OnInit, OnDestroy, AfterViewInit, Output, EventEmitter, Input, ElementRef, ViewChild, ViewChildren, QueryList, SimpleChanges, NgZone, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { countryPhoneCodes } from 'src/app/constants/phoneInternalization';
import { encrypt } from 'src/app/utils/encryptHelper';
import { CategoryService } from 'src/app/_service/category.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RegistrationComponent } from '../../registration/registration.component';
import { TermsAndConditionsComponent } from '../../sharedComponents/terms-and-conditions/terms-and-conditions.component';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';
import { CountryService } from 'src/app/_service/country.service';
import { TVNavigationService } from 'src/app/_service/tv-navigation.service';
import { TvKeyboardService } from 'src/app/_service/tv-keyboard.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { GuestTokenService } from 'src/app/_service/guest-token.service';

@Component({
  selector: 'app-india-auth',
  templateUrl: './india-auth.component.html',
  styleUrls: ['./india-auth.component.css']
})
export class IndiaAuthComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output() stepChange = new EventEmitter<number>();
  @Output() authTypeChange = new EventEmitter<string>();
  busy = false;
  public recaptchaVerifier: firebase.auth.RecaptchaVerifier;
  captchaVerified: boolean = false;
  public sent: boolean;
  studioAuth:string = 'toqqer';
  steps = 1;
  confirmationResult;
  formGroup: FormGroup;
  windowRef: any;
  invalidOtpError: string = 'auth/invalid-verification-code';
  invalidOtp: boolean = false;
  appComponent: any;
  remainingTime: number = 60;
  isResendDisabled: boolean = false;
  loading:boolean = false;
  verificationId:string = '';
  @Input() deviceId:string;
  @Input() selectedCountry:string;
  separateDialCode = false;
  otpValue: string = '';
  showOtp: boolean = false;
  otpInputKey: string = 'initial';
  @ViewChild('otpContainer', { static: false }) otpContainer: ElementRef;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  otpConfig = {
    length: 6,
    inputClass: 'custom-otp-input',
    allowNumbersOnly: true,
    isPasswordInput: false,
    autofocus: true,
    inputType: 'tel',
  };
  maxNationalLength = 10;
  @Input() authMethods: any[] = [];
  activeAuthMethod: string = '';

  // TV Navigation properties (step 1)
  @ViewChild('phoneInput', { static: false }) phoneInput: ElementRef;
  @ViewChild('tcCheckbox', { static: false }) tcCheckbox: ElementRef;

  // Fallback link uses a setter because it's gated by *ngIf="backupAuthMethod"
  // which only becomes truthy after the async authMethods @Input populates —
  // typically after the initial 100ms registerFormNavigation runs. The setter
  // fires the moment Angular binds the ref, so we re-register synchronously.
  private _fallbackLink: ElementRef;
  @ViewChild('fallbackLink', { static: false })
  set fallbackLinkRef(el: ElementRef) {
    this._fallbackLink = el;
    if (el && this.isTV && this.steps === 1) {
      const currentIdx = this.focusedFieldIndex >= 0 ? this.focusedFieldIndex : 0;
      setTimeout(() => this.registerFormNavigation(currentIdx), 0);
    }
  }
  get fallbackLink(): ElementRef { return this._fallbackLink; }

  // Shared between steps (both have submit button)
  @ViewChild('submitBtn', { static: false }) submitBtn: ElementRef;

  // TV Navigation properties (step 2)
  @ViewChild('wrongNumberBtn', { static: false }) wrongNumberBtn: ElementRef;
  @ViewChild('resendBtn', { static: false }) resendBtn: ElementRef;

  isTV = false;
  focusedFieldIndex = -1;
  fallbackFocusIndex = 4;
  private focusSubscription: Subscription;
  private regionId = 'auth-form-region';
  private otpAbortController: AbortController | null = null;

  constructor(
    private dialog:MatDialog,
    private toastr: ToastrService,
    private authService: AuthenticateserviceService,
    private fb: FormBuilder,
    private categService:CategoryService,
    private toastrService: CustomControlsService,
    private router: Router,
    private wl: WhiteLabelService,
    private iosBridge: IosBridgeService,
    private countryService: CountryService,
    private tvNav: TVNavigationService,
    private tvKeyboard: TvKeyboardService,
    private deviceService: DeviceService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private guestTokenService: GuestTokenService
    ) {
      const firebaseConfig = {
        apiKey: "AIzaSyA1Xl6t7H0F-niShxXFCBFAAT-8l_v6zq0",
        authDomain: "toqqer-app-dev-e5f3e.firebaseapp.com",
        databaseURL: "https://toqqer-app-dev-e5f3e.firebaseio.com",
        projectId: "toqqer-app-dev-e5f3e",
        storageBucket: "toqqer-app-dev-e5f3e.appspot.com",
        messagingSenderId: "470163066954",
        appId: "1:470163066954:web:5642c6aa16311e47ba56b3",
        measurementId: "G-F1MTN5WSRY"
      };
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }
      this.isTV = this.deviceService.isTV();
    }
  
  ngOnInit() {
    this.formGroup = this.fb.group({
      phoneNumber: ['', Validators.required],
      tcAgree: [false, Validators.requiredTrue],
      optNumber: ['', [Validators.minLength(6), Validators.maxLength(6)]]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedCountry'] && this.formGroup) {
      const current = changes['selectedCountry'].currentValue;
      this.formGroup.get('phoneNumber')?.reset();
      this.updatePhoneValidation(current);
    }
  }
  
  getDialCodeByName(countryName: string) {
    const country = this.countryService.getCountries().find(c => c.code.toLowerCase() === countryName.toLowerCase());
    return country?.dialCode ?? '';
  }
  
  updatePhoneValidation(countryCode: string) {
    const country = this.countryService.getCountries().find(c => c.code.toLowerCase() === countryCode.toLowerCase());
    if (!country) return;
    this.maxNationalLength = country.maxLength;
    const ctrl = this.formGroup.get('phoneNumber');
    ctrl?.setValidators([
      Validators.required,
      Validators.pattern(`^[0-9]{${country.minLength},${country.maxLength}}$`)
    ]);
    ctrl?.updateValueAndValidity();
  }

  getOtpDigits(): string[] {
    return Array.from({ length: 6 }, (_, i) => i.toString());
  }

  get activeMethods(): any[] {
    return this.authMethods || [];
  }

  get primaryAuthMethod(): string {
    if (this.activeAuthMethod) return this.activeAuthMethod;
    const methods = this.activeMethods;
    const primary = methods.find(m => m.primary === true);
    return primary ? primary.method : (methods.length > 0 ? methods[0].method : 'SMS');
  }

  get backupAuthMethod(): string {
    const methods = this.activeMethods;
    if (methods.length < 2) return '';
    const currentIndex = methods.findIndex(m => m.method === this.primaryAuthMethod);
    const nextIndex = (currentIndex + 1) % methods.length;
    return currentIndex !== nextIndex ? methods[nextIndex].method : '';
  }

  switchAuthMethod(method: string): void {
    if (method === 'EMAIL') {
      this.authTypeChange.emit('EMAIL');
      return;
    }
    this.activeAuthMethod = method;
    // Method swap only changes the fallback link's INNER TEXT — the DOM
    // node and the focusable items list are unchanged. So we don't need to
    // re-register; just re-affirm focus on the fallback link the user just
    // pressed Enter on. The defensive second activate-after-microtask handles
    // any competing focus shift from change-detection side effects.
    if (this.isTV) {
      const targetIndex = this.fallbackFocusIndex;
      setTimeout(() => {
        this.tvNav.activateRegion(this.regionId, targetIndex);
        Promise.resolve().then(() => {
          this.tvNav.activateRegion(this.regionId, targetIndex);
        });
      }, 100);
    }
  }

  getMethodLabel(method: string): string {
    switch (method) {
      case 'WHATSAPP': return 'WhatsApp';
      case 'EMAIL': return 'Email';
      default: return 'SMS';
    }
  }

  ngAfterViewInit() {
    setTimeout(() => this.mountRecaptcha(), 0);

    if (this.isTV) {
      setTimeout(() => {
        this.registerFormNavigation();

        // Re-register ONLY when form validity actually changes (adds/removes
        // submit button from focus list). On every other status change (e.g.,
        // checkbox toggle while phone is empty), the focusable items don't
        // change — re-registering would just knock focus back to index 0.
        let lastValid = this.formGroup?.valid;
        this.formGroup.statusChanges.subscribe(() => {
          if (this.steps !== 1) return;
          const nowValid = this.formGroup.valid;
          if (nowValid === lastValid) return;
          lastValid = nowValid;
          // Capture index from the component's local state, which mirrors
          // tvNav focus$ updates synchronously and is more reliable than
          // tvNav.getFocusedIndex() at this async statusChanges callback.
          const currentIdx = this.focusedFieldIndex >= 0
            ? this.focusedFieldIndex
            : this.tvNav.getFocusedIndex();
          this.registerFormNavigation(currentIdx);
          // Defensive re-activate after CD settles, in case the validity flip
          // triggered a downstream side effect that stole focus to index 0
          // (e.g., submit button becoming enabled triggers a re-render path).
          setTimeout(() => {
            this.tvNav.activateRegion(this.regionId, currentIdx);
          }, 50);
        });

        // Subscribe to focus changes
        this.focusSubscription = this.tvNav.focus$.subscribe(focusKey => {
          if (focusKey && focusKey.startsWith(this.regionId + ':')) {
            this.focusedFieldIndex = parseInt(focusKey.split(':')[1], 10);
          } else if (this.focusedFieldIndex !== -1) {
            this.focusedFieldIndex = -1;
          }
        });
      }, 100);
      // Note: fallback link registration happens via the @ViewChild setter
      // for fallbackLink (declared on the class) — it fires the moment Angular
      // binds the ref, which handles the async authMethods → backupAuthMethod
      // → element-render → ViewChild timing race deterministically.
    }
  }

  private otpTimeout: any;
  onOtpChange(otp: string): void {
    this.otpValue = otp;
    clearTimeout(this.otpTimeout);
    if (otp.length === this.otpConfig.length) {
      this.closeKeyboard();
      this.otpTimeout = setTimeout(() => this.onSubmit(), 500);
    }
  }

  closeKeyboard(): void {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement) activeElement.blur();
  }

  /**
   * Fix backspace on Android TV WebView.
   * The ng-otp-input library relies on the browser natively deleting the
   * character during keydown before keyup fires. On Android TV, KEYCODE_DEL
   * does NOT trigger native text deletion for type=tel maxlength=1 inputs,
   * so the library's backspace logic never activates. This keydown listener
   * explicitly clears the value and moves focus backward.
   */
  private setupTvOtpBackspace(): void {
    if (!this.isTV || !this.otpContainer) return;

    const inputs = this.otpContainer.nativeElement.querySelectorAll(
      'input.otp-input'
    ) as NodeListOf<HTMLInputElement>;

    inputs.forEach((input: HTMLInputElement, index: number) => {
      input.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Backspace' || event.keyCode === 8) {
          event.preventDefault();

          if (input.value) {
            // Clear current input and notify Angular / ng-otp-input
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
          } else if (index > 0) {
            // Already empty — move to previous input and clear it
            const prev = inputs[index - 1];
            prev.value = '';
            prev.dispatchEvent(new Event('input', { bubbles: true }));
            prev.focus();
          }
        }
      });
    });
  }

  toggleOtpVisibility(): void {
    this.showOtp = !this.showOtp;
    if (this.otpContainer) {
      const inputs = this.otpContainer.nativeElement.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
      inputs.forEach((input: HTMLInputElement) => {
        if (this.showOtp) {
          input.classList.remove('masked');
        } else {
          input.classList.add('masked');    
        }
      });
    }
  }
  

  onWrongNumberClick(){
    this.steps = 1;
    this.stepChange.emit(this.steps);
    this.isResendDisabled = false;
    this.remainingTime = 60;
    this.captchaVerified = false;
    setTimeout(() => this.mountRecaptcha(), 0);

    // Re-register form navigation after step change
    if (this.isTV) {
      setTimeout(() => this.registerFormNavigation(), 100);
    }
  }

  get f() {
    return this.formGroup.controls;
  }

  // Step 2 focus-field name resolver. The registered order is
  // [otp, resend, wrong, submit], but TVNavigationService filters out the
  // Resend button while isResendDisabled is true (aria-disabled="true"), so the
  // index we receive on focus$ is into the *filtered* list. Map accordingly.
  get focusedStep2Field(): string | null {
    const idx = this.focusedFieldIndex;
    if (idx < 0) return null;
    const order = this.isResendDisabled
      ? ['otp', 'wrong', 'submit']
      : ['otp', 'resend', 'wrong', 'submit'];
    return order[idx] ?? null;
  }

  async nextStep () {
    if(this.studioAuth == 'firebase'){
      const appVerifier = this.windowRef.recaptchaVerifier;
      if (this.steps === 1) {
        firebase.auth().signInWithPhoneNumber("+" + this.formGroup.value.phoneNumber, appVerifier)
          .then((confirmationResult) => {
            this.steps = 2;
            this.stepChange.emit(this.steps);
            this.sent = true;
            this.confirmationResult = confirmationResult;
            this.windowRef.recaptchaVerifier.clear ();

            // Re-register form navigation after step change
            if (this.isTV) {
              setTimeout(() => this.registerFormNavigation(), 100);
            }
          })
          .catch((err) => {
            console.log('sms not sent', err);
          });
      }else {
        this.steps = 1;
        this.stepChange.emit(this.steps);

        // Re-register form navigation after step change
        if (this.isTV) {
          setTimeout(() => this.registerFormNavigation(), 100);
        }
      }
    }else if(this.studioAuth === 'toqqer'){
      if (!this.captchaVerified) {
        this.showWarning('Please complete the verification first.');
        return;
      }
      const countryCode = this.getDialCodeByName(this.selectedCountry);
      this.loading = true;
      this.sendOtp(countryCode, this.primaryAuthMethod);
    }
  }

  private mountRecaptcha(): void {
    if(this.isTV){
      this.captchaVerified= true; 
      return ;
    }
    try {
      try { this.recaptchaVerifier?.clear(); } catch {}
      const container = document.getElementById('recaptcha-container');
      if (!container) return;
      container.textContent = '';
      this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
        size: 'normal',
        callback: () => {
          this.captchaVerified = true;
          this.cdr.detectChanges();
        },
        'expired-callback': () => {
          this.captchaVerified = false;
          this.cdr.detectChanges();
        }
      });
      this.recaptchaVerifier.render();
    } catch (e) {
      console.warn('reCAPTCHA mount failed:', e);
    }
  }

  private sendOtp(countryCode: string, authMethod?: string) {
    this.authService.toqqerSignInWithPhoneNumber(
      this.formGroup.value.phoneNumber, countryCode, this.deviceId, authMethod
    ).subscribe((result) => {
      if (result.status === 'SUCCESS') {
        this.loading = false;
        this.steps = 2;
        this.stepChange.emit(this.steps);
        this.verificationId = result.verificationId;
        this.showInfo(result.message);
        this.startTimer();

        if (this.isTV) {
          setTimeout(() => this.registerFormNavigation(), 100);
        } else {
          this.cdr.detectChanges();
          setTimeout(() => this.initAutoOtp(), 300);
        }
      } else if (result.status === 'FAILED') {
        this.loading = false;
        this.showWarning(result.message);
      }
    }, (error) => {
      this.loading = false;
      this.showError(error?.error?.message || error?.message);
    });
  }

  onResendOtpClick(){
    this.loading = true;
    const countryCode = this.getDialCodeByName(this.selectedCountry);
    this.authService.toqqerSignInWithPhoneNumber(this.formGroup.value.phoneNumber, countryCode, this.deviceId, this.primaryAuthMethod).subscribe((result)=>{
      if(result.status === 'SUCCESS'){
        this.loading = false;
        this.showInfo(result.message);
        this.verificationId = result.verificationId;
        this.startTimer();
      }else if(result.status === 'FAILED' && result.message === 'OTP is expired, User needs new session'){
        this.loading = false
        this.steps = 1;
        this.stepChange.emit(this.steps);
        this.showWarning(result.message);
      }else{
        this.loading = false;
        this.showWarning(result.message)
      }
    },(error)=>{
      this.loading = false;
      this.showError(error?.message);
    })
  }

  startTimer() {
    this.isResendDisabled = true; 
    const interval = setInterval(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;
      } else {
        clearInterval(interval);
        this.isResendDisabled = false;
        this.remainingTime = 60;
      }
    }, 1000);
  }

  onSubmit() {
    console.log("this.formGroup.value.optNumber:", this.formGroup.value.optNumber);
    if(this.studioAuth == 'firebase'){
      if (this.otpValue != null) {
        this.confirmationResult.confirm(this.otpValue)
          .then((res) => {
            console.log('verification code entered was correct.', res);
            firebase.auth().currentUser.getIdToken().then((idToken)=> {
              console.log("firebase  token for current user=" + idToken);
              console.log("before service call");
              this.authService.generateJwtToken(idToken).subscribe(result => {
                console.log("idToken: ", result, idToken);
                if (result ) {
                  console.log("after service call");
                  this.appComponent.initPlayer();
                  localStorage.setItem('contact', encrypt(this.formGroup.value.phoneNumber));
                  this.router.navigate(["/cc_prime"]);
                  this.categService.getChannelInfoByUserId().subscribe((result)=>{
                    localStorage.setItem('channelData', JSON.stringify(result));
                  })
                    this.toastr.success('Token Successfully created, for login..');
                } else {
                  console.log("New user loregistrationgged in");
                  localStorage.setItem('fb_token', idToken);
                  localStorage.setItem('fb_user_id', res.user.uid);
                  localStorage.setItem('new_number', this.formGroup.value.phoneNumber);
                  const dialogRef = this.dialog.open(RegistrationComponent, {
                   height: 'auto',
                    panelClass: 'custom-dialog-container'
                  });
                
                  dialogRef.afterClosed().subscribe(result => {
                    console.log('The dialog was closed');
                  });
                }
              });
            });
          })
          .catch((err) => {
            console.log("insinde [hne number verification error block", err);
            this.invalidOtp = err.code === this.invalidOtpError || false;
          });
      } else {
        console.log('No verification code entered');
      }
    }else if(this.studioAuth === 'toqqer'){
      if(this.otpValue){
        const deviceId =  localStorage.getItem('deviceId');
        this.loading = true;
        this.authService.toqqerVerifyOtp(this.otpValue,this.verificationId, deviceId).subscribe((otpResult)=>{
          this.loading = false;
          if(otpResult.status === 'SUCCESS'){
            localStorage.setItem('refreshToken',otpResult.response.idToken)
            if(otpResult.response.idToken){
              this.authService.toqqerUserLogin(otpResult.response.idToken).subscribe((userDetails:any)=>{
                this.guestTokenService.clearGuestState();
                localStorage.setItem('token', userDetails.refreshToken);
                this.authService.isAuthenticatedSubject.next(true);
                localStorage.setItem('screenName', userDetails.data.screenName);
                localStorage.setItem('userName', userDetails.data.userName)
                localStorage.setItem('userId', userDetails.data.localUserId);
                localStorage.setItem('profileImage', userDetails.data.profileImage);
                localStorage.setItem('description', userDetails.data.description);
                localStorage.setItem('contact',userDetails.data.phoneNumber);
                localStorage.setItem('appDarkMode','true');
                console.log('sending userid and token to ios');
                this.iosBridge.login({
                  userId: userDetails.data.localUserId,
                  token: userDetails.refreshToken
                });
                const redirectUrl = localStorage.getItem('redirectAfterLogin');
                localStorage.removeItem('redirectAfterLogin');
                if (redirectUrl && !redirectUrl.startsWith('/login')) {
                  this.router.navigateByUrl(redirectUrl, { replaceUrl: true });
                } else {
                  const wlChannel = localStorage.getItem('wl_channel');
                  const defaultRoute = wlChannel ? `/${wlChannel}/v` : '/v';
                  this.router.navigate([defaultRoute], { replaceUrl: true });
                }
                this.showSuccess(`Welcome! 🖐️ ${userDetails.data.screenName}`)
              },(error)=>{
                this.steps = 1;
                this.showError(error?.message);
                this.loading = false;
              })
            }else if(otpResult.response.preRegToken!=''){
              console.log("New user logged in");
              localStorage.setItem('preRegToken', otpResult.response.preRegToken);
              localStorage.setItem('new_number', this.formGroup.value.phoneNumber);
              const route = this.wl.getPrefixedRoute('registration');
              this.router.navigate([route], { replaceUrl: true });
            }
          }else if(otpResult.status === 'FAILED' && otpResult.message === 'OTP is expired, User needs new session'){
            this.loading = false
            this.steps = 1;
            this.stepChange.emit(this.steps);
            this.showWarning(otpResult.message);
          }else if(otpResult.status === 'FAILED' && otpResult.message === 'OTP is not verified, Crossed maximum attempt of verification, Record is expired, User needs new session'){
            this.loading = false;
            this.steps = 1;
            this.stepChange.emit(this.steps);
            this.showWarning(otpResult.message);
          }else{
            this.loading = false;
            this.showError(otpResult.message);
          }
        },(error)=>{
          this.showError("Something went wrong. Please check your connection...")
          this.loading = false;
        })
      }
    }
  };

  openTermsDialog(url:string){
    const dialogRef = this.dialog.open(TermsAndConditionsComponent,{
      width:'auto',
      data:{url}
    })
    dialogRef.afterClosed().subscribe(result=>{
      console.log("Dialog CLosed")
    })
  }

  /**
   * Register form fields with TV navigation
   * Step 1: phone input, checkbox, submit button
   * Step 2: OTP container, submit button, resend, wrong number
   */
  registerFormNavigation(initialFocusIndex: number = 0): void {
    if (!this.isTV) return;

    // Unregister any existing region
    this.tvNav.unregisterRegion(this.regionId);

    if (this.steps === 1) {
      // Step 1 focus order:
      // 0: Phone input
      // 1: T&C checkbox
      // 2: Send OTP button (only when form valid)
      // 3: Fallback link (switch auth method) — always available
      const focusableItems: ElementRef[] = [];

      if (this.phoneInput) focusableItems.push(this.phoneInput);
      if (this.tcCheckbox) focusableItems.push(this.tcCheckbox);

      const isFormValid = this.formGroup?.valid;
      if (isFormValid && this.submitBtn) focusableItems.push(this.submitBtn);

      // Fallback link always focusable so user can switch auth method
      if (this.fallbackLink) {
        this.fallbackFocusIndex = focusableItems.length;
        focusableItems.push(this.fallbackLink);
      }

      if (focusableItems.length > 0) {
        this.tvNav.registerRegion({
          id: this.regionId,
          type: 'form',
          elementRef: this.phoneInput || this.tcCheckbox || this.submitBtn,
          focusableItems
        });
        this.tvNav.activateRegion(this.regionId, initialFocusIndex);
      }
    } else if (this.steps === 2) {
      // OTP verification step — registered in visual DOM order so D-pad UP/DOWN
      // matches what the user sees: otp → resend → wrong number → confirm.
      const focusableItems: ElementRef[] = [];

      if (this.otpContainer) focusableItems.push(this.otpContainer);
      if (this.resendBtn) focusableItems.push(this.resendBtn);
      if (this.wrongNumberBtn) focusableItems.push(this.wrongNumberBtn);
      if (this.submitBtn) focusableItems.push(this.submitBtn);

      if (focusableItems.length > 0) {
        const firstElement = focusableItems[0];
        this.tvNav.registerRegion({
          id: this.regionId,
          type: 'form',
          elementRef: firstElement,
          focusableItems
        });
        // Explicitly activate so focus is visible after step transition
        this.tvNav.activateRegion(this.regionId, 0);
      }

      // Prevent native focus on ng-otp-input's internal <input> elements.
      // Without this, D-pad navigation triggers the Android system keyboard
      // alongside the TV grid keyboard. Only affects TV — web inputs stay normal.
      this.disableNativeOtpFocus();
    }
  }

  /**
   * On TV: set tabindex=-1 and readonly on ng-otp-input's internal inputs
   * to prevent the Android system keyboard from appearing.
   */
  private disableNativeOtpFocus(): void {
    if (!this.isTV || !this.otpContainer) return;
    const neutralize = () => {
      const inputs = this.otpContainer.nativeElement.querySelectorAll('input');
      inputs.forEach((input: HTMLInputElement) => {
        input.setAttribute('tabindex', '-1');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('inputmode', 'none');
        input.style.caretColor = 'transparent';
        input.blur();
      });
    };
    // Run twice — ng-otp-input can render its inputs late
    setTimeout(neutralize, 50);
    setTimeout(neutralize, 300);
  }

  onPhoneKeydown(event: KeyboardEvent): void{
    if(!this.isTV) return;
    if(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)){
      return;
    }
    if(event.key === 'Enter'){
      event.preventDefault();
      event.stopPropagation();
      this.onPhoneInputActivate();
      return;
    }
    event.preventDefault();
  }

  /**
   * Called when user presses Enter on phone input field
   * Opens grid keyboard for phone number entry
   */
  onPhoneInputActivate(): void {
    if (!this.isTV) return;

    const currentValue = this.formGroup.get('phoneNumber')?.value || '';

    this.tvKeyboard.show({
      initialValue: currentValue,
      inputType: 'tel',
      maxLength: this.maxNationalLength,
      placeholder: 'Enter phone number',
      onSubmit: (value: string) => {
        this.formGroup.patchValue({ phoneNumber: value });
        this.tvKeyboard.restoreFocus();
      },
      onCancel: () => {
        this.tvKeyboard.restoreFocus();
      }
    });
  }

  /**
   * Intercept ENTER on the OTP container so the key event
   * never propagates into ng-otp-input's internal <input> elements.
   */
  onOtpEnterKey(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    // Blur any OTP input that may have received focus
    const active = document.activeElement as HTMLElement;
    if (active?.tagName === 'INPUT' && this.otpContainer?.nativeElement.contains(active)) {
      active.blur();
    }
    this.onOtpBoxActivate(0);
  }

  /**
   * Handle OTP box activation - open keyboard for OTP digit entry
   */
  onOtpBoxActivate(boxIndex: number): void {
    if (!this.isTV) return;

    // Get current OTP value
    const currentOtp = this.otpValue;

    this.tvKeyboard.show({
      initialValue: currentOtp,
      inputType: 'tel',
      maxLength: 6,
      placeholder: 'Enter 6-digit OTP',
      onSubmit: (value: string) => {
        this.otpValue = value;
        // Pipe digits into ng-otp-input's visual boxes
        this.fillOtpInputBoxes(value);
        this.onOtpChange(value);
        this.tvKeyboard.restoreFocus();
      },
      onCancel: () => {
        this.tvKeyboard.restoreFocus();
      }
    });
  }

  /**
   * Mobile auto-read OTP:
   * - WebOTP API (Android Chrome): reads the incoming SMS and returns the code
   * - autocomplete="one-time-code" (iOS Safari): shows a "From Messages" suggestion
   * Only runs on non-TV devices after step 2 is rendered.
   */
  private initAutoOtp(): void {
    // iOS Safari: set autocomplete so the keyboard suggests the code
    if (this.otpContainer) {
      const inputs = this.otpContainer.nativeElement.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
      inputs.forEach((input: HTMLInputElement) => {
        input.setAttribute('autocomplete', 'one-time-code');
      });
    }

    // Android Chrome: WebOTP API auto-reads the SMS code
    if (!('OTPCredential' in window)) {
      console.log('[WebOTP] OTPCredential not supported');
      return;
    }

    const ac = new AbortController();
    this.otpAbortController = ac;

    console.log('[WebOTP] listening for OTP...');

    (navigator.credentials as any).get({
      otp: { transport: ['sms'] },
      signal: ac.signal
    }).then((otpCredential: any) => {
      console.log('[WebOTP] credential received:', otpCredential);
      const code: string = otpCredential?.code;
      console.log('[WebOTP] code:', code);
      if (!code) {
        console.log('[WebOTP] code is empty, aborting');
        return;
      }
      this.ngZone.run(() => {
        this.fillOtpCode(code);
      });
    }).catch((err: any) => {
      console.log('[WebOTP] error:', err);
    });
  }

  private fillOtpCode(code: string, attempt: number = 0): void {
    console.log('[WebOTP] fillOtpCode attempt', attempt, 'code:', code);
    this.otpValue = code;

    // Try library setValue first
    if (this.ngOtpInput) {
      console.log('[WebOTP] calling ngOtpInput.setValue()');
      this.ngOtpInput.setValue(code);
    } else {
      console.log('[WebOTP] ngOtpInput ref is null');
    }

    // DOM-level fill as backup — find inputs anywhere in the form
    const otpInputs = document.querySelectorAll('ng-otp-input input') as NodeListOf<HTMLInputElement>;
    console.log('[WebOTP] found', otpInputs.length, 'OTP input elements via document query');
    if (otpInputs.length > 0) {
      otpInputs.forEach((input: HTMLInputElement, i: number) => {
        const digit = code[i] || '';
        input.value = digit;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // If neither ref was available and we haven't retried too many times, retry
    if (!this.ngOtpInput && otpInputs.length === 0 && attempt < 5) {
      console.log('[WebOTP] refs not ready, retrying in 300ms...');
      setTimeout(() => {
        this.cdr.detectChanges();
        this.fillOtpCode(code, attempt + 1);
      }, 300);
      return;
    }

    // Auto-submit if full OTP
    if (code.length === this.otpConfig.length) {
      this.closeKeyboard();
      setTimeout(() => this.onSubmit(), 500);
    }
  }

  /**
   * Programmatically fill ng-otp-input's internal <input> elements.
   * The TV keyboard bypasses the component's normal input flow,
   * so we set values directly and re-apply readonly to prevent
   * the system keyboard from appearing.
   */
  private fillOtpInputBoxes(value: string): void {
    if (!this.otpContainer) return;
    const inputs = this.otpContainer.nativeElement.querySelectorAll('input');
    inputs.forEach((input: HTMLInputElement, i: number) => {
      input.value = value[i] || '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    // Re-apply readonly since dispatching input events can reset it
    this.disableNativeOtpFocus();
  }

  showPassword:boolean;
  togglePassword(){
    this.showPassword = !this.showPassword;
  }

  showInfo(message:any) {
    this.toastrService.showNotification(
      'info',
      '',
      message,
      3000
    );
  }

  showSuccess(message:any) {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }

  showError(message:any) {
    this.toastrService.showNotification(
      'error',
      '',
      message,
      3000
    );
  }

  showWarning(message:any) {
    this.toastrService.showNotification(
      'warning',
      '',
      message,
      3000
    );
  }

  ngOnDestroy(): void {
    if (this.focusSubscription) {
      this.focusSubscription.unsubscribe();
    }
    if (this.isTV) {
      this.tvNav.unregisterRegion(this.regionId);
    }
    if (this.otpAbortController) {
      this.otpAbortController.abort();
    }
  }
}
